<template>
  <div class="main">
    <div class="title">珠宝鉴赏服务协议</div>
    <div class="content">
      <div class="item">
        <div>一、什么是鉴赏</div>
        <div>每周从周一到星期天为一个签到循环</div>
      </div>
      <div class="item">
        <div>二、鉴赏须注意</div>
        <div>
          每天签到一次即可领取0.01克金砂，签到不领取，在第二
          天凌晨刷新，不可累计领取
        </div>
      </div>
    </div>
    <div class="btn">已阅读，并同意</div>
  </div>
</template>

<script>
export default {
  name: "GmcsWebH5Agreement",

  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="less" scoped>
.main {
  background: url("../../assets/appreciateAgreementBackground.png") no-repeat;
  height: 100vh;
  background-size: 100% 100%;
  overflow: hidden;
  position: relative;
  .content {
    display: flex;
    flex-direction: column;
    min-height: 263px;
    margin: 0 auto;
    width: 652px;
    margin-top: 24px;
    color: #ffffff;
    font-size: 28px;
    .item {
      width: 645px;
      min-height: 101px;
      margin-top: 24px;
      > div:nth-child(1) {
        margin-bottom: 24px;
      }
    }
  }
  .title {
    font-size: 36px;
    color: #facc6e;
    font-weight: bold;
    margin: 100px 0 0 231px;
  }
  .btn {
    width: 244px;
    height: 64px;
    background-color: #ffffff;
    border-radius: 16px;
    position: absolute;
    bottom: 120px;
    left: 253px;
    color: #ea9052;
    font-size: 28px;
    text-align: center;
    line-height: 64px;
  }
}
</style>
